import { widgetAspectRatioPolicySchema } from '@lucimark/shared/helpers/widgetAspectRatioPolicy'
import z from 'zod'

/** JSON Schema (or constrained subset) for widget config fields. Stored in asset metadata for dynamic form generation. */
export const widgetConfigSchemaSchema = z.record(z.string(), z.unknown())

export const widgetPackageJsonSchema = z.object({
  name: z.string(),
  version: z.string(),
  lucimark: z.object({
    description: z.string().optional(),
    width: z.number(),
    height: z.number(),
    /**
     * `mandatory` (default when omitted): section aspect should match widget reference aspect; player uses fixed design canvas + contain.
     * `optional`: responsive widget; iframe fills section; reference width/height still used for thumbnails/previews.
     */
    aspectRatioPolicy: widgetAspectRatioPolicySchema.optional(),
    /** Optional JSON Schema for widget configuration (keys, types, lucimarkScope: campaign/playlist/frame). */
    config: widgetConfigSchemaSchema.optional(),
    /** If true, campaign editor can mark this widget as a singleton (one instance per campaign). */
    singletonCapable: z.boolean().optional()
  })
})

export type TWidgetPackageJson = z.infer<typeof widgetPackageJsonSchema>
